export default "<span class=\"error\">\r\n  <span>{{data}}</span>\r\n</span>\r\n"